import { useExperiment } from "@hopper-b2b/experiments";
import { useSessionContext } from "@/components/AuthModule/SessionContext";

export const useShowCarsSearch = (): boolean => {
  const enableCarsSearch = useExperiment("EnableCarsSearch");
  const { sessionInfo } = useSessionContext();
  const isCarBookingEligible =
    sessionInfo?.userDetails?.eligibility?.enableCarBooking === true;

  return enableCarsSearch && isCarBookingEligible;
};
